// extracted by mini-css-extract-plugin
module.exports = {"contentSection":"PromotionalBanner_contentSection__jE35M","imgContainer":"PromotionalBanner_imgContainer__2ht9w"};